<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    :key="drawerKey"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="状态" prop="type" >
        <a-select v-model="form.type" placeholder="请选择状态">
          <a-select-option :value="0">用户端</a-select-option>
          <a-select-option :value="1">师傅端</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="名称" prop="title" >
        <a-input v-model="form.title" placeholder="请输入名称" />
      </a-form-model-item>
      <a-form-model-item label="版本号" prop="versionNumber" >
        <a-input v-model="form.versionNumber" placeholder="请输入版本号" />
      </a-form-model-item>
      <a-form-model-item label="证件信息" prop="certificate" >
        <a-input v-model="form.certificate" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="图片地址" prop="picture" >
        <file-upload
          type="image"
          :defaultList="form.pictureArr"
          :count="1"
          @input="getImg($event, 'picture')"
        ></file-upload>
      </a-form-model-item>
      <a-form-model-item label="app备案号" prop="record" >
        <a-input v-model="form.record" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="公司全称" prop="company" >
        <a-input v-model="form.company" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addIntro, getIntro, updateIntro } from '@/api/intro/intro'
import { guid } from '@/components/图片上传/utils/ruoyi'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        pictureArr: [],
        type: null,

        title: null,

        versionNumber: null,

        certificate: null,

        picture: null,

        record: null,

        company: null,

        createTime: null,

        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      drawerKey: 0,
      rules: {
        type: [
          { required: true, message: '状态不能为空', trigger: 'change' }
        ],
        // title: [
        //   { required: true, message: '名称不能为空', trigger: 'blur' }
        // ],
        // versionNumber: [
        //   { required: true, message: '版本号不能为空', trigger: 'blur' }
        // ],
        // picture: [
        //   { required: true, message: '图片地址不能为空', trigger: 'blur' }
        // ],
        record: [
          { required: true, message: 'app备案号不能为空', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '公司全称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        pictureArr: [],
        type: null,
        title: null,
        versionNumber: null,
        certificate: null,
        picture: null,
        record: null,
        company: null,
        createTime: null,
        remark: null
      }
      this.drawerKey += 1
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },

    /* ******************* 上传图片数据处理 start ******************** */
    /**
     * 前端 需要将图片格式处理成数组，方便数据回显
     */
    setImgData(field, img) {
      const fieldImgArr = []
      if (img.indexOf(',') === -1) {
        // 单图
        if (this.form[`${field}Count`] === 1) {
          if (img) {
            fieldImgArr.push({
              uid: guid(8, 10),
              name: img,
              status: 'done',
              halfUrl: img,
              url: img,
              path: img
            })
          }
        }
      } else {
        // 多图
        if (this.form[`${field}Count`] > 1) {
          const imgArr = img.split(',')
          if (imgArr.length) {
            imgArr.map(item => {
              fieldImgArr.push({
                uid: guid(8, 10),
                name: img,
                status: 'done',
                halfUrl: img,
                url: item,
                path: item
              })
            })
          }
        }
      }
      return fieldImgArr
    },
    /**
     * 上传图片成功回调
     */
    getImg(info, fieldName) {
      console.log('getImg 接收到的数据:', info, 'fieldName:', fieldName)

      // 兼容处理：如果传入的是字符串，转换为数组格式
      if (typeof info === 'string') {
        if (info) {
          this.form[fieldName] = info
          this.form[`${fieldName}Arr`] = [{
            uid: guid(8, 10),
            status: 'done',
            url: info,
            path: info,
            halfUrl: info
          }]
        } else {
          this.form[fieldName] = ''
          this.form[`${fieldName}Arr`] = []
        }
        console.log('设置后的', fieldName, ':', this.form[fieldName])
        return
      }

      // 数组格式处理
      if (!info || !Array.isArray(info) || info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
        console.log('图片列表为空，已清空', fieldName)
        return
      }

      // 单图上传（count=1），直接取第一张图片的 URL
      if (info.length === 1) {
        const firstFile = info[0]
        // 优先使用 url，其次使用 path，最后使用 halfUrl
        const imageUrl = firstFile.url || firstFile.path || firstFile.halfUrl
        if (imageUrl) {
          this.form[fieldName] = imageUrl
          this.form[`${fieldName}Arr`] = info
          console.log('单图上传，设置后的', fieldName, ':', this.form[fieldName])
        } else {
          console.error('无法获取图片地址，文件对象:', firstFile)
          this.$message.error('获取图片地址失败，请重试')
        }
      } else {
        // 多图上传，用逗号连接所有图片 URL
        const urls = info.map(ele => {
          return ele.url || ele.path || ele.halfUrl
        }).filter(url => url) // 过滤掉空值
        if (urls.length > 0) {
          this.form[fieldName] = urls.join(',')
          this.form[`${fieldName}Arr`] = info
          console.log('多图上传，设置后的', fieldName, ':', this.form[fieldName])
        } else {
          console.error('无法获取图片地址，文件列表:', info)
          this.$message.error('获取图片地址失败，请重试')
        }
      }
    },
    /**
     * 点击视频 弹窗打窗口播放视频
     */
    async handlePreview(file) {
      this.previewImage = this.form.video || file.video
      this.previewVisible = true
      this.$nextTick(() => {
        this.$refs.myVideo.play()
      })
    },
    handleCancel() {
      this.previewVisible = false
    },
    /* ******************* 上传图片数据处理 end   ******************** */

    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : (Array.isArray(ids) ? ids[0] : ids)
      if (id == null || id === undefined) return
      getIntro({ id }).then(response => {
        const data = response.data
        if (!data || String(data.id) !== String(id)) return
        this.form = { ...data }
        this.form.pictureArr = []
        if (this.form.picture) {
          this.form.pictureArr.push({
            uid: guid(8, 10),
            status: 'done',
            halfUrl: this.form.picture,
            url: this.form.picture,
            path: this.form.picture
          })
        }
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateIntro(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.reset()
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addIntro(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.reset() // 新增成功后重置表单
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
